// ====== 允許回跳的網域（白名單）======
// 例：.env 內設定
// VUE_APP_MAIN_BASE_URL=https://a.example.com
// VUE_APP_MOBILE_BASE_URL=https://m.a.example.com
const ALLOW_ORIGINS = [
  process.env.VUE_APP_MAIN_BASE_URL,
  process.env.VUE_APP_MAIN_SMS_BASE_URL,
  process.env.VUE_APP_MAIN_AICHAT_BASE_URL, // 有就加，沒有會被 filter 掉
].filter(Boolean);

// 取第一個白名單當 fallback base（沒有就用當前站台）
const FALLBACK_BASE = new URL(ALLOW_ORIGINS[0] || window.location.origin);

function pickSafeUrl(raw) {
  if (!raw) return null;
  try {
    // 支援相對路徑（/xxx）與絕對 URL（https://...）
    const u = raw.startsWith("/") ? new URL(raw, FALLBACK_BASE) : new URL(raw);

    const isHttp = u.protocol === "http:" || u.protocol === "https:";
    if (!isHttp) return null;

    const ok = ALLOW_ORIGINS.some((o) => u.origin === new URL(o).origin);
    return ok ? u : null;
  } catch {
    return null;
  }
}

function appendParams(u, kv) {
  Object.keys(kv).forEach((k) => {
    const v = kv[k];
    if (v != null && v !== "") u.searchParams.set(k, v);
  });
  return u;
}

/**
 * 儲存當前頁面 URL，登入完成後會自動導回
 */
export function saveRedirectUrl() {
  localStorage.setItem("redirectAfterLogin", window.location.href);
}

/**
 * 儲存當前頁面 URL，儲值完成後會自動導回
 */
export function saveRedirectUrlForPurchase() {
  localStorage.setItem("redirectAfterPurchase", window.location.href);
}

/**
 * 判斷是否有儲存 redirect URL，如果有就帶上參數跳轉，並回傳 true。
 * 若沒有儲存任何跳轉資訊，回傳 false。
 *
 * @param {string} emailEncrypt 加密 email
 * @param {string} token 登入成功後的登入 token
 * @returns {boolean} 是否有執行跳轉
 */
export function redirectIfHasSavedUrl(emailEncrypt, token) {
  const raw = localStorage.getItem("redirectAfterLogin");
  if (!raw) return false;

  localStorage.removeItem("redirectAfterLogin");

  const u = pickSafeUrl(raw) || new URL("/", FALLBACK_BASE);
  appendParams(u, { emailEncrypt, t: token });

  window.location.assign(u.toString());
  return true;
}

/**
 * 判斷是否有儲存 redirect URL，如果有就帶上參數跳轉，並回傳 true。
 * 若沒有儲存任何跳轉資訊，回傳 false。
 *
 * @param {string} emailEncrypt 加密 email
 * @returns {boolean} 是否有執行跳轉
 */
export function redirectIfHasSavedUrlForPurchase(emailEncrypt) {
  const raw = localStorage.getItem("redirectAfterPurchase");
  if (!raw) return false;

  localStorage.removeItem("redirectAfterPurchase");

  const u = pickSafeUrl(raw) || new URL("/", FALLBACK_BASE);
  appendParams(u, { emailEncrypt });

  window.location.assign(u.toString());
  return true;
}
